/*
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-11 12:16:44
 * @LastEditTime: 2020-10-09 17:24:31
 * @Description: File description
 */
import Vue from 'vue'
import store from './store'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/sharePage'
    },
    // 老带新首页
    {
      path: '/sharepage',
      name: 'sharePage',
      component: () => import(/* webpackChunkName: "saveposter" */ '@/inviteNew/views/home'),
      meta: { title: '邀请有礼' }
    },
    // 老带新新用户注册页
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "saveposter" */ '@/inviteNew/views/register'),
      meta: { title: '加入学而思网校，一起进步' }
    },
    // 新用户注册成功奖励页
    {
      path: '/discount',
      name: 'discount',
      component: () => import(/* webpackChunkName: "saveposter" */ '@/inviteNew/views/discount'),
      meta: { title: '优惠券展示' }
    },
    // 老带新生成海报页
    {
      path: '/savePoster',
      name: 'savePoster',
      component: () => import(/* webpackChunkName: "saveposter" */ '@/inviteNew/views/savePoster'),
      meta: { title: '邀请有礼' }
    },
    // 老带新自定义海报页
    {
      path: '/posterList',
      name: 'posterList',
      component: () => import(/* webpackChunkName: "posterlist" */ '@/inviteNew/views/posterList'),
      meta: { title: '制作邀请海报' }
    },
    // 个性化海报保存页
    {
      path: '/saveSelfPoster',
      name: 'saveSelfPoster',
      component: () => import(/* webpackChunkName: "posterlist" */ '@/inviteNew/views/saveSelfPoster'),
      meta: { title: '邀请有礼' }
    },
    // 兑换课程页
    {
      path: '/courseExchange',
      name: 'courseExchange',
      component: () => import(/* webpackChunkName: "posterlist" */ '@/inviteNew/views/courseExchange'),
      meta: { title: '邀好友兑课程' }
    },
    // 我的奖励页
    {
      path: '/rewardPage',
      name: 'rewardPage',
      component: () => import(/* webpackChunkName: "posterlist" */ '@/inviteNew/views/rewardPage'),
      meta: { title: '我的奖励' }
    },
    // 奖励提现页
    {
      path: '/withDrawRecord',
      name: 'withDrawRecord',
      component: () => import(/* webpackChunkName: "posterlist" */ '@/inviteNew/views/withDrawRecord'),
      meta: { title: '提现记录' }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: () => import(/* webpackChunkName: "posterlist" */ '@/inviteNew/views/withdraw'),
      meta: { title: '提现活动说明' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // ...
  store.dispatch('checkLogin').then(() => {
    next()
  }).catch(() => {
    if (to.name === 'sharePage' || to.name === 'rewardPage' || to.name === 'register') return next()
    next('/sharePage')
  })
})

router.afterEach((to) => {
  document.title = to.meta.title || '学而思网校'
})

export default router
